import { adminIngestApiUrl } from './adminIngestApi';
import { adminApiHeaders } from './adminApiAuth';

export interface AdminMediaUploadResult {
  key: string;
  reference: string;
}

/**
 * Envia imagem para S3 via API. Retorna `reference` no formato s3:chave para persistir em cidades/experiências.
 */
export async function uploadAdminMedia(file: File, category: string): Promise<AdminMediaUploadResult> {
  const form = new FormData();
  form.append('file', file);
  form.append('category', category);
  const res = await fetch(adminIngestApiUrl('/api/admin/media/upload'), {
    method: 'POST',
    headers: adminApiHeaders(),
    body: form,
  });
  const text = await res.text();
  if (!res.ok) {
    let msg = text || `Erro ${res.status}`;
    try {
      const j = JSON.parse(text) as { error?: string };
      if (j.error) msg = j.error;
    } catch {
      /* ignore */
    }
    if (res.status === 404) {
      msg +=
        ' — Verifique: API em execução (:5000), admin com `npm run dev` (proxy /api), e `VITE_API_URL` sem sufixo `/api` (evita /api/api/…). O upload é POST; abrir a URL no navegador é GET.';
    }
    throw new Error(msg);
  }
  const data = JSON.parse(text) as AdminMediaUploadResult;
  if (!data.reference?.startsWith('s3:') || !data.key) {
    throw new Error('Resposta inválida da API de upload.');
  }
  return data;
}
